import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { IllustrativeView } from '@component/illustrative_view.component';
import { TopBar } from '@component/top_bar.component';
import { useResolveController } from '@visiba/instantiation';
import { useEffect } from 'react';
import { ViewRedRobinController } from '../view_red_robin.controller';

export function ScreenNhsLoginRequired() {
	const controller = useResolveController(ViewRedRobinController);
	const analytics = useAnalyticContext();

	useEffect(() => {
		analytics.service.trackPageView({ customTitle: 'Red Robin: NHS login required' });
	}, [analytics]);

	return (
		<>
			<TopBar.Content onAbort={null} />
			<IllustrativeView
				title={withTranslation('View.RedRobin.NhsLoginRequired.Title')}
				description={withTranslation('View.RedRobin.NhsLoginRequired.Body')}
				illustration='error'
				callToAction={withTranslation('View.RedRobin.NhsLoginRequired.Button')}
				callToActionCallback={() => controller.goToReceptionHome()}
			/>
		</>
	);
}
